import React from 'react';
import './Cards.css';
import CardItem from './CardItem';


function Cards() {
  return (
    <div className='cards' style={{backgroundColor:"#dcdcdc"}}>
      <h1>Completed Projects</h1>
     
      <div className='cards__container'>
      <div className='cards__items'>
          <CardItem
            src='images/Ba 35/Ba 35 (1).jpg'
            text='Two Story House '
            label='BA 36'
            location='Wellampitiya'
            price='LKR 14 Million'
            description='4 Bedroom House'
            path='/ba35'
          />
        </div>
        <div className='cards__items'>
          <CardItem
            src='images/Masjid/Masjid (1).jpg'
            text='Malwana Masjid'
            label='BA 35'
            location='Malwana'
            price='LKR 10 Million'
            description='Ground Floor Slab'
            path='/ba36'
          />
          </div>

          <div className='cards__items'>
            <CardItem
              src='images/Ba03/BA 03 (13).jpg'
              text='G+ 3 Story House'
              label='BA 03'
              location='DEmatagoda'
              price='LKR 70 Million'
              description='4 Uniit Apartment'
              path='/ba3'
            />
            </div>
            <div className='cards__items'>
            <CardItem
              src='images/Ba07/Ba 7 (15).jpg'
              text='2 Story House'
              label='Ba 07'
              location='Wellampitiya'
              price='LKR 16 Million'
              description='2 Unit House'
              path='/ba7'
            />
            </div>
            <div className='cards__items'>
            <CardItem
              src='images/Ba17/BA 17 (1).jpg'
              text='Single Story House'
              location='Thihariya'
              price='LKR 7 Million'
              description='3 Bedroom House'
              label='Ba 17'
              path='/ba17'
            />
          
          </div>
          <div className='cards__items'>
            <CardItem
              src='images/Ba19/BA 19 (1).jpg'
              text='Two Story House'
              location='Kuliyapitiya'
              price='LKR 15 Million'
              description='4 Bedroom House'
              label='BA 19'
              path='/ba19'
            /></div>
            <div className='cards__items'>
            <CardItem
              src='images/Ba21/BA 21 (1).jpg'
              text='Two Story House'
              location='Kotikawaththa'
              price='LKR 14 Million'
              description='4 Bedroom House'
              label='BA 21'
              path='/ba21'
            />
            </div>
            <div className='cards__items'>
            <CardItem
              src='images/Ba27/BA 27 (1).jpg'
              text='Two Story House & Shop'
              location='Pasyala'
              price='LKR 25 Million'
              description='2 Unit House & 3 Shop'
              label='BA 27'
              path='/ba27'
            />
         </div>
         <div className='cards__items'>
          
            <CardItem
              src='images/Ba29/BA 29 (1).jpg'
              text='Two Story House'
              location='Kotikawaththa'
              price='LKR 15 Million'
              description='3 Bedroom house'
              label='BA 29'
              path='/ba29'
            />
            </div>
            <div className='cards__items'>
            <CardItem
              src='images/Ba25/BA 25 (1).jpg'
              text='Two Story House'
              location='Goththatuwa'
              price='LKR 16 Million'
              description='3 Bedroom House'
              label='BA 25'
              path='/ba25'
            />
            </div>
            <div className='cards__items'>
            <CardItem
              src='images/Ba20/BA 20 (1).jpg'
              text='Two Story House'
              location='Brindiyawaththa'
              price='LKR 14 Million'
              description='2 Unit House'
              label='BA 20'
              path='/ba20'
            />
          </div>
            <div className='cards__items'>
            <CardItem
              src='images/Ba13/BA 13 (5).jpg'
              text='Single Story House'
              location='Wellampitiya'
              price='Lkr 9 Million'
              description='2 Bedroom House'
              label='BA 13'
              path='/ba13'
            />
            </div>
            </div>
            <div className='cards__container'>
            <div className='cards__items' >
            <CardItem
              src='images/Ba05/BA 5 (5).jpg'
              text='Two Story House'
              location='Wellampitiya'
              price='LKR 14 Million'
              description='4 Bedroom House'
              label='BA 05'
              path='/ba5'
            />
          </div>
      </div>
    </div>
  );
}

export default Cards;
